import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const GrowthIcon: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><path d="M19.5 13.125V7.5H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /><path d="M3.75 16.5L10.125 10.125L13.5 13.5L18.75 8.25" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="bevel" /></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default GrowthIcon;